import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=bb8ecd66&scoped=true"
import script from "./invitation.vue?vue&type=script&lang=js"
export * from "./invitation.vue?vue&type=script&lang=js"
import style0 from "./invitation.vue?vue&type=style&index=0&id=bb8ecd66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8ecd66",
  null
  
)

export default component.exports